import { useEffect, useState } from "react"

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState<boolean | undefined>(undefined)

  useEffect(() => {
    const mdScreenMql = window.matchMedia(`(min-width: 48rem)`)
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }
    mdScreenMql.addEventListener("change", onChange)
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    return () => mdScreenMql.removeEventListener("change", onChange)
  }, [])

  return !!isMobile
}

export function useIsTouchDevice() {
  const [isTouchDevice, setIsTouchDevice] = useState<boolean | undefined>(undefined)

  useEffect(() => {
    const canHoverMql = window.matchMedia(`(hover: hover)`)
    const onChange = (ev: MediaQueryListEvent) => {
      setIsTouchDevice(!ev.matches);
    }
    canHoverMql.addEventListener("change", onChange)
    setIsTouchDevice(!canHoverMql.matches);
    return () => canHoverMql.removeEventListener("change", onChange)
  }, [])

  return !!isTouchDevice
}
